import DashboardLayout from 'layout/dashboardLayout';
import Dropdown from 'components/Dropdown';
import Dropdownbody, {
  stylesForDropDown,
} from 'components/Dropdown/dropdownbody';
import { CaretdownfilledIcon, CaretRightIcon } from 'components/icons';
import React, { useState } from 'react';
import { globalStyles } from 'styles';
import {
  fetchDashboardSummary,
  fetchDashboardTransactions,
  fetchOverviewGraph,
  fetchTransactionAmount,
  fetchTransactionVolume,
  fetchWalletBalance,
} from 'store/actions/dashboard';

import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

import {
  formatDateForApi,
  formatDateForApiUtc,
  statusTextColorMapping,
  TransactionTableFilter,
} from 'libs';
import TransactionTable from 'container/Transactions/transaction-table';
import DateFilter from 'components/DateFilter';
import SquareRadioFilter from 'components/Form/SquareRadioFilter';
import { startCase } from 'lodash';
import ToolTip from 'components/Tooltip';
import classname from 'classname';
import { INDEX, TRANSACTIONS } from 'router/routes';
import styles from './new-dashbaord.module.scss';
import EmptyChart from './empty-chart';
import DashboardChart from './dashboard-chart';
import ActivateCard from './activate-card';

export default function NewDashboard() {
  const [date, setDate] = React.useState({ from: '', to: '' });
  const [currentPage, setCurrentPage] = React.useState(1);
  const [displayByDropdownOpen, setDisplayByFilterDropdownOpen] =
    React.useState(false);
  const [columnsToshow, setColumsToShow] = React.useState(
    TransactionTableFilter,
  );

  const dispatch = useDispatch();
  const getDashboardSummary = React.useCallback(
    (params) => dispatch(fetchDashboardSummary(params)),
    [dispatch],
  );
  const getOverviewGraph = React.useCallback(
    (params) => dispatch(fetchOverviewGraph(params)),
    [dispatch],
  );
  const getWalletBalance = React.useCallback(() => {
    dispatch(fetchWalletBalance());
  }, [dispatch]);
  const getfetchDashboardTransactions = React.useCallback(
    (params) => {
      dispatch(fetchDashboardTransactions(params));
    },
    [dispatch],
  );
  const getTransactionAmount = React.useCallback(
    (params) => {
      dispatch(fetchTransactionAmount(params));
    },
    [dispatch],
  );
  const getTransactionVolume = React.useCallback(
    (params) => {
      dispatch(fetchTransactionVolume(params));
    },
    [dispatch],
  );

  const {
    summary,
    walletBalance,
    transactions,
    accountChecker,
    graph,
    transactionAmount,
    transactionVolume,
  } = useSelector((state) => state.dashboard);
  const { businessSetupRequired = true } = useSelector(
    (state) => state.common?.user,
  );

  const { user } = useSelector((state) => state.common);
  const { firstName, role } = user?.merchantUser;
  const { data: txt, pagination, inProgress } = transactions;
  const { data: graphData, inProgress: loadingGraphData } = graph;

  // Change page
  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
    getfetchDashboardTransactions({ ...pagination, page: data.selected });
  };

  React.useEffect(() => {
    const formatedStartDate = formatDateForApi(date.from);
    const formatedEndDate = formatDateForApi(date.to);
    const params = {
      ...(formatedStartDate && { startDate: formatedStartDate }),
      ...(formatedEndDate && { endDate: formatedEndDate }),
    };

    if (date.from && date.to) {
      getfetchDashboardTransactions({ ...params, limit: 5 });
    }
    getDashboardSummary(params);
    if (date.from && date.to) {
      const params = {
        startDate: formatDateForApiUtc(date.from),
        endDate: formatDateForApiUtc(date.to),
        merchantId: user?.merchantId,
      };
      getOverviewGraph(params);
      getTransactionAmount(params);
      getTransactionVolume(params);
    }
  }, [
    getOverviewGraph,
    date,
    getfetchDashboardTransactions,
    user.merchantId,
    getDashboardSummary,
    getTransactionAmount,
    getTransactionVolume,
  ]);

  React.useEffect(() => {
    getWalletBalance();
  }, [getWalletBalance]);

  const handleFilterUpdate = (e) => {
    let { name, value, type, checked } = e.target;
    value = type === 'checkbox' ? checked : value;
    const coloumns = { ...columnsToshow, [name]: value };
    setColumsToShow(coloumns);
  };

  const completed = !businessSetupRequired || accountChecker.completed;

  return (
    <DashboardLayout>
      <div className={styles.dashbaord}>
        {!completed ? (
          <>
            <div>
              <h1 className={styles.title}>Welcome back, {firstName}🌤</h1>
              <p className={styles.subTitle}>
                Here is what's happening with your business today!
              </p>
            </div>
            <ActivateCard accountChecker={accountChecker} ownerType={role} />
            <EmptyChart accountChecker={accountChecker} ownerType={role} />
          </>
        ) : null}

        {completed ? (
          <>
            <div className={styles.headingGroup}>
              <div>
                <DateFilter date={date} setDate={setDate} />
              </div>
            </div>

            <DashboardChart
              summary={summary}
              walletBalance={walletBalance}
              graphData={graphData}
              loadingGraphData={loadingGraphData}
              transactionAmount={transactionAmount}
              transactionVolume={transactionVolume}
            />
          </>
        ) : null}
        {completed && (
          <>
            <div className={styles.dashboardtable}>
              <div
                className={`${globalStyles.flex} ${styles.headingTableGroup} ${globalStyles.alignItemsCenter}`}
              >
                <h1 className={styles.biggerheading}>
                  Most Recent Transactions
                </h1>
                <Dropdown
                  isOpen={displayByDropdownOpen}
                  setIsOpen={setDisplayByFilterDropdownOpen}
                  style={{ minWidth: '180px' }}
                  header={
                    <div
                      className={`${globalStyles.displayby} ${globalStyles.flex} ${globalStyles.alignItemsCenter}`}
                    >
                      <p>Display by: </p>
                      <CaretdownfilledIcon />
                    </div>
                  }
                >
                  <Dropdownbody filter>
                    {Object.entries(columnsToshow).map(([name, value]) => (
                      <button
                        className={stylesForDropDown.dropdownitem}
                        key={name}
                      >
                        <SquareRadioFilter
                          type="checkbox"
                          name={name}
                          checked={value}
                          onClick={handleFilterUpdate}
                        >
                          {startCase(name)}
                        </SquareRadioFilter>
                      </button>
                    ))}
                  </Dropdownbody>
                </Dropdown>
                <ToolTip
                  id="transaction-table-overview"
                  content="Use this to filter fields that you want to see in your transaction overview"
                />
                <Link
                  to={TRANSACTIONS}
                  className={classname(
                    globalStyles.viewall,
                    globalStyles.flex,
                    globalStyles.alignItemsCenter,
                  )}
                >
                  <span>View all</span>
                  <CaretRightIcon
                    fill="#18379A"
                    style={{ marginLeft: '5px' }}
                  />
                </Link>
              </div>
              <TransactionTable
                handlePageClick={handlePageClick}
                columnsToshow={columnsToshow}
                currentPage={currentPage}
                txt={txt}
                inProgress={inProgress}
                meta={pagination}
                statusTextColorMapping={statusTextColorMapping}
                hidePagination
              />
            </div>
          </>
        )}
      </div>
    </DashboardLayout>
  );
}
